import React from 'react';
import { withTheme } from 'styled-components';

const OpenDocIcon = ({ width, height, theme }) => {
  return (
    <svg 
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={ theme.themeColors.controlBar.rightPanel.icons.searchIcon.color }
      xmlns="http://www.w3.org/2000/svg" 
      data-ignore-click-outside="sidebar"
    >
      <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/>
      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
    </svg>
  );
};

export default withTheme(OpenDocIcon);
